import React from 'react';
import { StyleSheet, useWindowDimensions } from 'react-native';
import Svg, { Defs, Ellipse, FeGaussianBlur, FeMerge, FeMergeNode, FeOffset, Filter } from 'react-native-svg';

import { withOpacity } from '@/styles/styles';

import { CircleBottomGlowProps } from '../types';
import {
    BOTTOM_GLOW_BLUR_VALUE,
    BOTTOM_GLOW_EXTRA_WIDTH,
    BOTTOM_GLOW_HEIGHT,
    BOTTOM_GLOW_OFFSET,
} from '../utils/promotions-utils';

const styles = StyleSheet.create({
    canvas: {
        flex: 1,
        width: '100%',
        height: '100%',
    },
});

export const CircleBottomGlow = ({ headerHeight, color }: CircleBottomGlowProps) => {
    const { width } = useWindowDimensions();

    const getRy = () => {
        const maxRy = 300;
        const value = (BOTTOM_GLOW_EXTRA_WIDTH + width) / 2;

        return value > maxRy ? maxRy : value;
    };

    return (
        <Svg
            style={[styles.canvas, { height: headerHeight.value }]}
            width="100%"
            viewBox={`0 0 ${width + BOTTOM_GLOW_EXTRA_WIDTH} ${headerHeight.value}`}
        >
            <Defs>
                <Filter id="blurFilter" x="-50%" y="-50%" width="200%" height="200%">
                    <FeGaussianBlur in="SourceGraphic" stdDeviation={`${BOTTOM_GLOW_BLUR_VALUE}`} />
                    <FeOffset dx="0" dy="10" result="offsetblur" />
                    <FeMerge>
                        <FeMergeNode in="SourceGraphic" />
                        <FeMergeNode in="offsetblur" />
                    </FeMerge>
                </Filter>
            </Defs>

            <Ellipse
                cx={(BOTTOM_GLOW_EXTRA_WIDTH + width) / 2}
                cy={headerHeight.value - BOTTOM_GLOW_OFFSET + BOTTOM_GLOW_HEIGHT}
                rx={headerHeight.value + BOTTOM_GLOW_HEIGHT}
                ry={getRy()}
                fill={withOpacity(color, 0.3)}
                filter="url(#blurFilter)"
            />
        </Svg>
    );
};
